import React, { useState } from 'react'
import { PaymentSection } from './styles'
import { useBooleanState } from '../../helpers'
import PaymentMethodModal from './PaymentMethodModal'
import DeleteCardModal from './DeleteCardModal'
import NewPaymentMethod from './NewPaymentMethod'
import ChoosePaymentDropdown from './ChoosePaymentDropdown'
import PaymentsAccountView from './PaymentsAccountView'
import { updateUser } from '../../services/GraphQlClientService'
import { useUserContext } from '../../components/UserContext'

/**
 *
 *
 * @param {*} {selectedPaymentMethodFn, createdPaymentMethodFn, isDesktop, selectedPaymentMethodId, paymentMethods}
 * @return {*}
 */

const PaymentCard = ({
  selectedPaymentMethodFn,
  createdPaymentMethodFn,
  isDesktop,
  selectedPaymentMethodId,
  paymentMethods,
  account
}) => {
  const context = useUserContext()
  const me = context.user
  const setUser = context.setUser
  const [hasExistingPaymentMethods, setHasExistingPaymentMethods] = useState(
    me?.paymentMethods && me?.paymentMethods.length ? true : false
  )
  const [isPaymentMethodMenuVisible, toggleIsPaymentMethodMenuVisible] =
    useBooleanState()
  const [showAddPaymentMethod, toggleShowAddPaymentMethod] = useBooleanState()
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [cardToDestroy, setCardToDestroy] = useState(null)

  if (!hasExistingPaymentMethods) {
    if (paymentMethods && paymentMethods.length) {
      setHasExistingPaymentMethods(true)
    }
  }

  const selectedPaymentMethod = paymentMethods
    ? paymentMethods.find(({ id }) => id === selectedPaymentMethodId)
    : []

  const togglePaymentSelected = methodId => {
    selectedPaymentMethodFn(methodId)
    toggleIsPaymentMethodMenuVisible()
  }

  const openDestroy = id => {
    setCardToDestroy(id)
    setDeleteModalOpen(true)
  }

  const setDefaultPayment = async id => {
    try {
      await updateUser({ id: me.id, defaultPaymentMethodId: id })
      setUser({
        ...me,
        defaultPaymentMethodId: id
      })
      let storage = JSON.parse(sessionStorage.getItem('book'))
      if (storage) {
        sessionStorage.setItem(
          'book',
          JSON.stringify({
            ...storage,
            selectedPaymentMethodId: id
          })
        )
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <PaymentSection account={account}>
      {hasExistingPaymentMethods ? (
        !account ? (
          <ChoosePaymentDropdown
            isPaymentMethodMenuVisible={isPaymentMethodMenuVisible}
            toggleIsPaymentMethodMenuVisible={toggleIsPaymentMethodMenuVisible}
            selectedPaymentMethod={selectedPaymentMethod}
            selectedPaymentMethodId={selectedPaymentMethodId}
            paymentMethods={paymentMethods}
            togglePaymentSelected={togglePaymentSelected}
            toggleShowAddPaymentMethod={toggleShowAddPaymentMethod}
          />
        ) : (
          <PaymentsAccountView
            me={me}
            openDestroy={openDestroy}
            setDefaultPayment={setDefaultPayment}
            toggleShowAddPaymentMethod={toggleShowAddPaymentMethod}
            toggleIsPaymentMethodMenuVisible={toggleIsPaymentMethodMenuVisible}
          />
        )
      ) : (
        <NewPaymentMethod
          data-testid="new-payment-method"
          id="new-payment-method"
          {...{
            createdPaymentMethodFn,
            paymentMethods
          }}
        />
      )}
      <PaymentMethodModal
        data-testid="payment-method-modal"
        isOpen={showAddPaymentMethod}
        close={toggleShowAddPaymentMethod}
        {...{
          createdPaymentMethodFn,
          isDesktop,
          me,
          paymentMethods
        }}
      />
      {cardToDestroy && (
        <DeleteCardModal
          isOpen={deleteModalOpen}
          closeModal={() => {
            setDeleteModalOpen(false)
            setCardToDestroy(null)
          }}
          isDesktop={isDesktop}
          cardToDestroy={cardToDestroy}
          paymentMethods={paymentMethods}
          me={me}
          setUser={setUser}
          selectedPaymentMethodId={selectedPaymentMethodId}
          setHasExistingPaymentMethods={setHasExistingPaymentMethods}
        />
      )}
    </PaymentSection>
  )
}

export default PaymentCard
